import { fontStyles } from '@/styles/typography';

import { CheckmarkIcon } from '@/ui/Icons/CheckmarkIcon';
import { CheckVerifiedIcon } from '@/ui/Icons/CheckVerifiedIcon';
import { MatchaGreenIcon } from '@/ui/Icons/MatchaGreenIcon';
import { XIconGray } from '@/ui/Icons/XIconGray';
import { ResponsiveBR } from '@/ui/ResponsiveBR';

import { StyledPrimaryCell, StyledH2, StyledParagraph, StyledSecondaryCell } from '../utils';

const PROS_TEXT_ITEMS = ['Aggregated liquidity', 'Trustless', 'Non-custodial'];

const CONS_TEXT_ITEMS = ['Fragmented liquidity', 'Requires deposits', 'Custodial apps'];

export const ComparisonSection = () => (
  <StyledPrimaryCell
    className="desktop:flex-row tablet:pl-15 tablet:pr-16 flex flex-col justify-between pr-6 pl-6"
    style={{
      background:
        'linear-gradient(48deg, rgba(252, 252, 253, 0.10) 44.23%, #FCFCFD 83.52%) 0 100%/246px no-repeat, url(/images/crosschain/diagonal-lines.svg) no-repeat left 0%, #fcfcfd',
    }}
  >
    <div className="tablet:mx-0 mx-5">
      <StyledH2>
        Better than CEXs
        <ResponsiveBR /> for L2 trading
      </StyledH2>
      <StyledParagraph className="max-w-[370px]">
        Trustless and non-custodial trades across chains. You stay in control of your funds.
      </StyledParagraph>
    </div>
    <StyledSecondaryCell className="tablet:left-0 tablet:translate-x-0 tablet:mt-18 desktop:mt-0 tablet:ml-auto desktop:ml-4 tablet:mr-auto desktop:mr-0 before:rounded-t-[1.25rem] relative left-1/2 mt-13 mr-0 ml-0 flex w-fit -translate-x-1/2 rounded-t-[1.25rem] border-none shadow-[0px_4px_36px_0px_rgba(0,0,0,0.04),0px_2px_6px_0px_rgba(0,0,0,0.05)] before:absolute before:inset-0 before:top-0 before:right-0 before:bottom-0 before:left-0 before:-m-[1px] before:border before:border-inherit before:bg-[radial-gradient(69.53%_56.79%_at_10.5%_0%,rgba(44,160,70,0.16)_0%,rgba(81,223,112,0.00)_100%)] before:content-['']">
      <div
        className="bg-primitive-basic-white border-primitive-alphadark-1600 border-r z-1 rounded-tl-[1.25rem]"
        style={{
          background:
            'radial-gradient(69.53% 56.79% at 10.5% 0,rgba(89,219,118,.06) 0,rgba(81,223,112,0) 100%),rgba(255,255,255,1)',
        }}
      >
        <div className="tablet:justify-start tablet:pt-8 tablet:pl-10 tablet:pb-5.5 border-b-primitive-alphadark-1600 flex min-h-[105px] flex-col justify-center border-1 border-transparent pt-5 pb-4 pl-4.5">
          <MatchaGreenIcon className="size-8" />
          <h5
            className={fontStyles({
              variant: 'H5',
              class:
                'tablet:text-[18px] tablet:leading-6 text-token-green-1000 mt-2 text-[12px] leading-4',
            })}
          >
            Matcha
          </h5>
        </div>
        <ul className="text-primitive-gray-800 tablet:pt-8 tablet:pb-8 tablet:pl-10 tablet:pr-10 mt-1 px-5 py-5">
          {PROS_TEXT_ITEMS.map((text) => (
            <li className="mt-4 flex items-center first:mt-0" key={text}>
              <div className="text-primitive-basic-white flex h-6 w-6 shrink-0 items-center justify-center rounded-[50%] bg-[linear-gradient(308.48deg,#02A863_-13.93%,rgba(2,168,99,0.49)_112.7%)] shadow-[0px_1px_3px_rgba(0,0,0,0.12),inset_0px_-1px_0px_rgba(0,0,0,0.16)]">
                <CheckmarkIcon />
              </div>
              <span
                className={fontStyles({
                  variant: 'BODY_LG',
                  className: 'text-token-gray-800 ml-3',
                })}
              >
                {text}
              </span>
            </li>
          ))}
        </ul>
      </div>
      <div
        className={
          'bg-primitive-basic-white z-1 rounded-tr-[1.25rem] first:bg-[radial-gradient(69.53%_56.79%_at_10.5%_0%,rgba(89,219,118,0.06)_0%,rgba(81,223,112,0.00)_100%),#FFF]'
        }
      >
        <div className="tablet:justify-start tablet:pt-8 tablet:pl-10 tablet:pb-5.5 border-b-primitive-alphadark-1600 flex min-h-[105px] flex-col justify-center border-1 border-transparent pt-5 pb-4 pl-4.5">
          <CheckVerifiedIcon />
          <h5
            className={fontStyles({
              variant: 'H5',
              class: 'tablet:text-[18px] tablet:leading-6 leading-4 mt-2 text-[12px]',
            })}
          >
            Centralized exchanges
          </h5>
        </div>
        <ul className="text-primitive-gray-800 tablet:py-8 tablet:px-10 desktop:pr-20 mt-1 px-5 py-5">
          {CONS_TEXT_ITEMS.map((text) => (
            <li className="mt-4 flex items-center first:mt-0" key={text}>
              <XIconGray className="size-7 flex-shrink-0" />
              <span
                className={fontStyles({
                  variant: 'BODY_LG',
                  className: 'text-token-gray-800 ml-3',
                })}
              >
                {text}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </StyledSecondaryCell>
  </StyledPrimaryCell>
);
